var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{attrs:{"icon":"","aria-label":_vm.$t('components.activity.ActivityInbox.title')},on:{"click":_vm.click}},[_c('v-badge',{attrs:{"value":_vm.hasUnseen,"content":`${_vm.unseenCount}`,"overlap":"","data-test-activity-inbox-badge":""}},[_c('v-icon',[_vm._v("mdi-inbox")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }